import { render } from "./ModuleUnit1.vue?vue&type=template&id=d457b5d2"
import script from "./ModuleUnit1.vue?vue&type=script&lang=js"
export * from "./ModuleUnit1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__